import { Suspense } from 'react'

import { createBrowserRouter } from 'react-router-dom'
import { RouterProvider } from 'react-router-dom'
import App from './App.jsx'
// import GalaxyParticlesExperience from './Components/Experiences/GalaxyParticles/index.jsx'
// import Shaders from './Components/Experiences/Shaders/index.jsx'
import { lazy } from 'react'
import WelcomePage from './Components/WelcomePage/index.jsx'

function Root() {
  const AnimatedObjects = lazy(() => import('./Components/Sandboxes/AnimatedObjects/index.jsx'))
  const Shaders = lazy(() => import('./Components/Sandboxes/Shaders/index.jsx'))
  const Galaxy = lazy(() => import('./Components/Sandboxes/GalaxyParticles/index.jsx'))
  const SurfaceMap = lazy(() => import('./Components/Sandboxes/SurfaceMap/index.jsx'))
  const TargetMorph = lazy(() => import('./Components/Sandboxes/TargetMorph/index.jsx'))

  const Charting = lazy(() => import('./Components/Sandboxes/Charting/index.jsx'))

  const Donuts = lazy(() => import('./Components/Sandboxes/Donuts/index.jsx'))

  const LabAlpha = lazy(() => import('./Components/Sandboxes/LabAlpha/index.jsx'))

  const router = createBrowserRouter([
    {
      element: <App />,
      children: [
        { path: '/', element: <WelcomePage /> },
        {
          path: 'galaxy',
          element: <Galaxy />
        },
        {
          path: 'animatedObjects',
          element: <AnimatedObjects />
        },
        {
          path: 'donuts',
          element: <Donuts />
        },
        {
          path: 'shaders',
          element: <Shaders />
        },
        {
          path: 'surface-map',
          element: <SurfaceMap />
        },
        {
          path: 'target-morph',
          element: <TargetMorph />
        },
        {
          path: 'charting',
          element: <Charting />
          // index: true,
        },
        {
          path: 'lab-alpha',
          element: <LabAlpha />
        }
      ]
    }
  ])

  return (
    <Suspense>
      <RouterProvider router={router} />
    </Suspense>
  )
}

export { Root }
